import { render, staticRenderFns } from "./AiBetaNote.vue?vue&type=template&id=fbb0f3d2&scoped=true"
import script from "./AiBetaNote.vue?vue&type=script&lang=js"
export * from "./AiBetaNote.vue?vue&type=script&lang=js"
import style0 from "./AiBetaNote.vue?vue&type=style&index=0&id=fbb0f3d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb0f3d2",
  null
  
)

export default component.exports